// components/LayerDeletionConfirmationModal.tsx
import React from 'react';
import { AlertTriangle } from '@/components/ui/lucide-memo';

const stopPropagation = (event: React.MouseEvent) => event.stopPropagation();

interface LayerDeletionConfirmationModalProps {
  isOpen: boolean;
  layerName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const LayerDeletionConfirmationModal: React.FC<LayerDeletionConfirmationModalProps> = ({
  isOpen,
  layerName,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur"
      onClick={onCancel}
    >
      <div
        className="bg-neutral-800 text-white rounded-lg shadow-2xl w-full max-w-md overflow-hidden border border-red-500/40"
        onClick={stopPropagation}
      >
        <div className="p-6 flex items-start space-x-4">
          <div className="mt-1">
            <AlertTriangle className="w-8 h-8 text-red-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Update Project History?</h2>
            <p className="text-sm text-neutral-300 leading-6">
              Layer '{layerName || 'Untitled Layer'}' is part of a validated version. Removing it will update that version, invalidate its preview, and may consolidate project checkpoints. This action changes the project&apos;s official history.
            </p>
          </div>
        </div>
        <div className="px-6 pb-6 flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-md bg-neutral-700 text-neutral-100 hover:bg-neutral-600 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-500 transition-colors font-semibold"
          >
            Update Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(LayerDeletionConfirmationModal);
